import { createApiClient } from '@monorepo/api-client';
import i18n from 'i18next';
import { logoutRequest } from 'store/auth/actions';
import { AuthTokenStorage } from 'store/auth/utils/authTokenStorage';
import { REFRESH_TOKEN_ERROR } from 'store/app/constants';
import { getDispatch } from 'store/dispatch';
import { resolveBrowserApiBaseUrl } from 'utils/apiBaseUrl';

export const api = createApiClient({
  baseUrl: resolveBrowserApiBaseUrl(process.env.API_URL),
  publicUrl: process.env.PUBLIC_URL || '',
  appTypeHeader: 'generate.TAX',
  refreshTokenErrorMessage: REFRESH_TOKEN_ERROR,
  getAccessToken: () => AuthTokenStorage.getAccessToken(),
  onAuthFailure: () => {
    getDispatch()?.(logoutRequest());
  },
  getDefaultErrorMessage: () => i18n.t('global.unexpected-error'),
});
